import { gql } from "@apollo/client";
import { AccountDeliveryDriverInput } from "../../types/AccountDeliveryDriverInput";
import { AccountDeliveryDriverInputType } from "../../types/AccountDeliveryDriverInputType";

const UPDATE_ACCOUNT_DELIVERY_DRIVER_RESPONSE_FIELDS = gql`
    fragment UpdateAccountDeliveryDriverResponseFields on UpdateAccountDeliveryDriverResponseType {
        success
        requiresConfirmation
        driverTaskStatuses
        originalInput {
            email
            countryCode
            phone
            password
            name
            avatarStorageToken
            status
            vehicleTypeId
            vehiclePlate
            vehicleImageS3KeysJson
            driverLicenseNumber
            dspCode
            isOnDuty
            isBlacklist
            isEmployed
            idDocumentType
            idDocumentNumber
            idDocumentImageS3KeysJson
        }
    }
`;

// DSP 入口
export const UPDATE_ACCOUNT_DELIVERY_DRIVER = gql`
    mutation UpdateAccountDeliveryDriver($accountId: Long!, $input: AccountDeliveryDriverInput!, $confirmed: Boolean!) {
        updateAccountDeliveryDriver(accountId: $accountId, input: $input, confirmed: $confirmed) {
            ...UpdateAccountDeliveryDriverResponseFields
        }
    }
    ${UPDATE_ACCOUNT_DELIVERY_DRIVER_RESPONSE_FIELDS}
`;

// 总部入口：别名保持响应字段名与 DSP 入口一致
export const UPDATE_ACCOUNT_DELIVERY_DRIVER_FOR_CENTRAL = gql`
    mutation UpdateAccountDeliveryDriverForCentral($accountId: Long!, $input: AccountDeliveryDriverInput!, $confirmed: Boolean!) {
        updateAccountDeliveryDriver: updateAccountDeliveryDriverForCentral(accountId: $accountId, input: $input, confirmed: $confirmed) {
            ...UpdateAccountDeliveryDriverResponseFields
        }
    }
    ${UPDATE_ACCOUNT_DELIVERY_DRIVER_RESPONSE_FIELDS}
`;

// 仓库入口：别名保持响应字段名与 DSP 入口一致
export const UPDATE_ACCOUNT_DELIVERY_DRIVER_FOR_WMS = gql`
    mutation UpdateAccountDeliveryDriverForWms($accountId: Long!, $warehouseId: Long!, $input: AccountDeliveryDriverInput!, $confirmed: Boolean!) {
        updateAccountDeliveryDriver: updateAccountDeliveryDriverForWms(accountId: $accountId, warehouseId: $warehouseId, input: $input, confirmed: $confirmed) {
            ...UpdateAccountDeliveryDriverResponseFields
        }
    }
    ${UPDATE_ACCOUNT_DELIVERY_DRIVER_RESPONSE_FIELDS}
`;

export interface UpdateAccountDeliveryDriverResponseType {
    success: boolean;
    requiresConfirmation: boolean;
    driverTaskStatuses: string[];
    originalInput?: AccountDeliveryDriverInputType | null;
}

export interface UpdateAccountDeliveryDriverResponse {
    updateAccountDeliveryDriver: UpdateAccountDeliveryDriverResponseType;
}

export interface UpdateAccountDeliveryDriverVariables {
    accountId: number;
    input: AccountDeliveryDriverInput;
    confirmed: boolean;
    // 仅仓库入口需要
    warehouseId?: number;
}
